import { Pageable, Sort } from "./table.model";

export class User {
    id: number;
    userName: string;
    level: number;
    parentType: string;
    parentTypeValue: string;
    parentName: string;
    email: string;
    lastAccessDate: Date;
    days: number;
    deActivationDate: Date;
    activationDate: Date;
    modifiedBy:number;
}


export class UsersList {
    content: User[];
    pageable: Pageable;
    last: boolean;
    totalPages: number;
    totalElements: number;
    number: number;
    sort: Sort;
    size: number;
    first: boolean;
    numberOfElements: number;
    empty: boolean;
    lastAccessDate: Date;
    days: number;
    deActivationDate: Date;
    activationDate: Date;
    modifiedBy:number;
}

export class SearchUser {
    userName: string ='';
    email?: string = '';
    lastAccessDate?: any = '';
    deActivationDate: Date;
    activationDate: Date;
}


export class CreateUser {
    password: string ="";
    userName: string;
    id: number;
    level: number = -1;
    parentType: string ="";
    parentId: number = 0;
    firstName?: string;
    lastName?: string;
    company?: string;
    postcode?: string;
    tel?: string;
    email?: string;
    created: Date;
    modified: Date;
}



export class UserInfo  extends CreateUser {
    active: boolean;
    newPasswordSet: boolean;
    name: string;
}

